import { WSQueryConfig } from "@ws-react-query";
import {
  concurrentActions,
  ListRequestQuery,
  WSServiceError
} from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL } from "../keys";
import {
  getPayeeEngagementsByPayeeId,
  PayeeEngagementsAPIFilter
} from "../../../services/payeeEngagement";
import times from "lodash/times";
import flatten from "lodash/flatten";
import { IPayeeEngagementListResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

export const useQueryPayeeEngagementsListByPayeeId = (
  payeeId: string,
  params = {} as any,
  config?: WSQueryConfig<IPayeeEngagementListResponse, WSServiceError>
) => {
  const { sort, ...filter } = params;

  const xWingspanPayerId = useXWingspanPayerId();

  return useWSQuery<IPayeeEngagementListResponse, WSServiceError>(
    [
      QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
      payeeId,
      params,
      xWingspanPayerId
    ],
    async () => {
      const pageSize = 1000;
      const {
        summary: { listSize },
        data
      } = await getPayeeEngagementsByPayeeId(payeeId, xWingspanPayerId, {
        filter,
        page: { size: pageSize, number: 1 },
        sort
      });

      const pages = Math.ceil(listSize / pageSize) - 1;

      const actions = times(pages).map(
        (_, i) => () =>
          getPayeeEngagementsByPayeeId(payeeId, xWingspanPayerId, {
            filter,
            page: { size: pageSize, number: i + 2 },
            sort
          })
      );

      const allPages = await concurrentActions(actions, {
        concurrentLimit: 5
      });

      return flatten([data, ...allPages.map(p => p.data)]);
    },

    {
      refetchOnMount: false,
      retry: false,
      ...config
    }
  );
};
